import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { HeaderModule } from './modules/header/header.module';
import { FooterComponent } from './components/footer/footer.component';
import { VerticalMenuComponent } from './components/vertical-menu/vertical-menu.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { CopyDirective } from './directives/copy.directive';
import { StorageService } from './services/storage.service';
import { HttpService } from './services/http.service';
import { SearchPipe } from './pipes/search.pipe';
import { FeatureTogglerDirective } from './directives/feature-toggler.directive';
import { FeatureTogglerService } from './services/feature-toggler.service';
import { FrameComponent } from './components/frame/frame.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { NotificationService } from './services/notification.service';
import { LoggerService } from './services/logger.service';
import { AlertComponent } from './components/alert/alert.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    TranslateModule
  ],
  declarations: [
    // Components
    FooterComponent,
    VerticalMenuComponent,
    PreloaderComponent,
    // Directives
    CopyDirective,
    FeatureTogglerDirective,
    // Filters
    SearchPipe,
    FrameComponent,
    ConfirmationComponent,
    AlertComponent
  ],
  exports: [
    FooterComponent,
    VerticalMenuComponent,
    HeaderModule,
    PreloaderComponent,
    CopyDirective,
    FeatureTogglerDirective,
    SearchPipe,
    FrameComponent,
    ConfirmationComponent,
    AlertComponent
  ],
  providers: [
    StorageService,
    FeatureTogglerService,
    HttpService,
    NotificationService,
    LoggerService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/core.module.ts